export default __webpack_public_path__ + "static/media/strategic-partner.ec8e7fa3.svg";